import React from 'react';
import { Card } from '../ui/card';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const KPIProprieta = ({ bookings, filters }) => {
  const filterBookings = (bookingsList) => {
    return bookingsList.filter(booking => {
      const bookingDate = new Date(booking.booking_date);
      const bookingYear = bookingDate.getFullYear();
      const bookingMonth = bookingDate.getMonth() + 1;
      const bookingQuarter = Math.ceil(bookingMonth / 3);
      if (bookingYear !== filters.year) return false;
      if (filters.period === 'month' && filters.month) return bookingMonth === parseInt(filters.month);
      if (filters.period === 'quarter' && filters.quarter) return bookingQuarter === parseInt(filters.quarter);
      if (filters.propertyId && booking.property_id !== filters.propertyId) return false;
      return true;
    });
  };

  const currentBookings = filterBookings(bookings);

  const getTopProperties = () => {
    const grouped = {};
    currentBookings.forEach(booking => {
      const property = booking.property_name || 'Sconosciuto';
      if (!grouped[property]) {
        grouped[property] = { name: property, count: 0, revenue: 0 };
      }
      grouped[property].count++;
      grouped[property].revenue += booking.guest_total || 0;
    });
    return Object.values(grouped)
      .sort((a, b) => b.revenue - a.revenue)
      .slice(0, 15);
  };

  const topProperties = getTopProperties();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">🏠 Analisi Proprietà</h2>
        <p className="text-gray-600">Performance per immobile</p>
      </div>

      <Card className="p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">🏠 Top 15 Proprietà per Ricavi</h3>
        <ResponsiveContainer width="100%" height={500}>
          <BarChart data={topProperties} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis dataKey="name" type="category" width={120} tick={{ fontSize: 10 }} />
            <Tooltip formatter={(value) => `€${value.toFixed(2)}`} />
            <Bar dataKey="revenue" fill="#7c3aed" name="Ricavi (€)" />
          </BarChart>
        </ResponsiveContainer>
      </Card>
    </div>
  );
};

export default KPIProprieta;